// extracted by css-extract-rspack-plugin
export default {"divider":"MenuDivider_divider__slzs5"};